/**
 * TapPay 彈窗內刷卡欄位的純決策函式。與 TPDirect SDK／伺服器溝通留給呼叫端，
 * 這裡只回答「現在能不能送出、要顯示什麼、拿到伺服器回應後該做什麼」。
 */

/**
 * TPDirect `onUpdate` 回呼帶的欄位狀態能不能送出取 prime。
 * @param {?{canGetPrime?: boolean, hasError?: boolean}} update
 * @returns {boolean}
 */
export function canSubmitCard(update) {
    return !!update && update.canGetPrime === true && !update.hasError;
}

/**
 * 依 TPDirect 欄位狀態碼（0 OK、1 未填、2 有誤、3 輸入中）組成提示文字。
 * @param {?{number?: number, expiry?: number, ccv?: number}} status
 * @returns {string}
 */
export function cardStatusMessage(status) {
    if (!status) {
        return '';
    }

    const codes = [status.number, status.expiry, status.ccv];

    if (codes.includes(2)) {
        return '卡片資訊有誤，請確認後重新輸入';
    }

    if (codes.includes(1)) {
        return '請完整填寫卡號、有效期限與安全碼';
    }

    return '';
}

/**
 * 依 `draw/card` 回應的四態決定前端下一步動作。
 * @param {?{state?: string, order_id?: number, result?: object|null, payment_url?: ?string, message?: ?string}} payload
 * @returns {{type: string, result?: object, url?: string, orderId?: number, message?: string}}
 */
export function cardOutcomeAction(payload) {
    if (!payload || typeof payload.state !== 'string') {
        return { type: 'error', message: '系統異常，請稍後再試' };
    }

    switch (payload.state) {
        case 'done':
            return { type: 'show_result', result: payload.result };
        case 'three_ds':
            return { type: 'redirect', url: payload.payment_url };
        case 'paying':
            return { type: 'poll', orderId: payload.order_id };
        case 'failed':
            return { type: 'show_error', message: payload.message || '本次抽獎未成立，請至訂單查看' };
        default:
            return { type: 'error', message: '系統異常，請稍後再試' };
    }
}
